import * as React from "react";
import {Route} from "react-router-dom";
import CordovaContext from "src/cordovaContext";
import LandingPage from '@components/landing/landing.component';
import FullScreenCard from "@components/common/fullscreencard/FullScreenCard";
import VarannanVeckaLogo from "@components/svg/varannanvecka";

class Landing extends React.Component {

    public render() {
        return (
            <>
                <CordovaContext.Consumer>
                    {
                        (cordovaApp) => {
                            return (true ? // temporary check if cordovaApp or not in the future
                                (<FullScreenCard sideElement={<VarannanVeckaLogo/>}>
                                    <LandingPage/>
                                </FullScreenCard>)
                                :
                                <Route path='/' component={() => {
                                    window.location.href = 'https://www.varannanvecka.app';
                                    return null;
                                }}/>);
                        }
                    }
                </CordovaContext.Consumer>
            </>
        );
    }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/containers/landing/landing.container.tsx